import type { RouteLocationNormalizedLoaded, Router } from 'vue-router'

/** The two shells' document pages — one component, two route names. */
const DOCUMENT_ROUTES = new Set(['qms-document', 'products-document'])

/**
 * The doc_id an in-app path opens, when that path is a document page and the
 * caller has somewhere better to open it than a new page (MYAC-1162).
 *
 * Returns null for every other link, which then navigates normally: this decides
 * what the CHAT claims for its side panel, not what a link is allowed to do.
 */
export function documentIdFromPath(router: Router, path: string): string | null {
  let resolved: RouteLocationNormalizedLoaded
  try {
    resolved = router.resolve(path) as unknown as RouteLocationNormalizedLoaded
  } catch {
    return null
  }
  if (!DOCUMENT_ROUTES.has(String(resolved.name ?? ''))) return null
  const docId = resolved.params?.docId
  const id = Array.isArray(docId) ? docId[0] : docId
  return id ? String(id) : null
}
